import $ from 'jquery';

$('.js-checkEmpty li:empty').addClass('is-empty');
